import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faSistrix } from '@fortawesome/free-brands-svg-icons';
import { Link, router, usePage } from '@inertiajs/react';
import deliveryWhite from '@/css/images/delivery-white.png';
import shield from '@/css/images/shield.png';
import dollorCurrency from '@/css/images/dollar-currency.png';
import supportWhite from '@/css/images/support-white.png';
import userIcon from '@/css/images/user-icon.png';
import basket from '@/css/images/basket.png';

import NavMenu from './nav-menu';
import { toast } from 'sonner';
import { useMobileNavigation } from '@/hooks/use-mobile-navigation';

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);


    return (
        <header className="header sticky-top">
            <TopHeader />
            <MainHeader setMenuOpen={setMenuOpen} />
            <NavMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        </header>
    )
}

function TopHeader() {
    const { settings } = usePage().props as any;

    return (
        <div className="top-header">
            <div className="container">
                <div className="top-header-row">

                    <div className="top-item">
                        <img src={deliveryWhite} alt="delivery-white" />
                        <div>
                            <span>Free UK Delivery </span>
                            <p>Fast & reliable service</p>
                        </div>
                    </div>

                    <div className="top-item">
                        <img src={shield} alt="shield" />
                        <div>
                            <span>100% GENUINE PRODUCTS</span>
                            <p>Direct from leading brands</p>
                        </div>
                    </div>

                    <div className="top-item">
                        <img src={dollorCurrency} alt="dollor-currency" />
                        <div>
                            <span>UP TO 10 YEAR WARRANTY </span>
                            <p>On selected products</p>
                        </div>
                    </div>

                    <div className="top-item">
                        <img src={supportWhite} alt="support-white" />
                        <div>
                            <span>EXPERT advice & SUPPORT</span>
                            <p>We're here to help</p>
                        </div>
                    </div>
                    <div className="top-item">
                        <a href={`tel:${settings.phone}`}><i className="fa-solid fa-phone"></i> {settings.phone}</a>
                        <a href={`mailto:${settings.email}`}><i className="fa-solid fa-envelope"></i> {settings.email}</a>
                    </div>


                </div>
            </div>
        </div>
    );
}

function MainHeader({ setMenuOpen }: { setMenuOpen: React.Dispatch<React.SetStateAction<boolean>> }) {
    const { auth } = usePage().props as any;
    const { cart_count, settings } = usePage().props as any;

    const [seachActive, setSearchActive] = useState(true)
    const [isLogin, setISLogin] = useState(false);

    const [searchProducts, setSearchProducts] = useState('');

    const handleWishlist = () => {

        if (!auth?.user) {
            toast.error('Please Login First!');
            return;
        }
        router.visit('/wishlist')
    }

    const handleSearch = () => {
        router.get('/shop',
            { search: searchProducts },
            {
                preserveState: true,
                replace: true,
                preserveScroll: true,
            }
        );
    }

    const removeXmark = () => {
        setSearchProducts('');
    }


    const formatTime = (time: string) => {
        return new Date(`1970-01-01T${time}`).toLocaleTimeString([], {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    };

    useEffect(() => {
        const SearchBox = () => {
            if (window.pageYOffset > 200) {
                setSearchActive(false);
            }
            else {
                setSearchActive(true);
            }
        }
        SearchBox();

        window.addEventListener("scroll", SearchBox);

        return () => {
            window.addEventListener('scroll', SearchBox);
        }

    }, []);


    const handleLaqout = () => {
        router.flushAll();
        router.post("/boilerLogout");
    }


    return (
        <div className="mid-header">
            <div className="container">
                <div className="mid-header-row">
                    {/* <!-- Logo --> */}
                    <div className="logo">
                        <Link href="/"><img src={settings.logo} alt="logo" /></Link>
                    </div>

                    {/* <!-- Search --> */}
                    <div className={`search-box ${seachActive === true ? "Active" : "InActive"}`}>
                        <input
                            type="text"
                            id='boilerHeaderSearch'
                            name='headerSearch'
                            placeholder="Search for boilers, air conditioners and more..."
                            value={searchProducts}
                            onChange={(e) => setSearchProducts(e.target.value)}
                        />
                        {
                            searchProducts && (
                                <FontAwesomeIcon icon={faXmark} className='fs-6 my-auto header-xmark' onClick={removeXmark} />
                            )
                        }
                        <button type="button" onClick={handleSearch}><i className="fa-brands fa-sistrix"></i></button>
                    </div>

                    {/* <!-- Right Side --> */}
                    <div className="header-right">
                        {/* <!-- Mobile Menu Trigger --> */}
                        <div className="mobile-menu-trigger" onClick={() => setMenuOpen(prev => !prev)}>
                            <span></span>
                        </div>

                        {/* mobile Logo */}
                        <div className="mobile-logo">
                            <Link href="/"><img src={settings.logo} alt="logo" /></Link>
                        </div>
                        {/* <div className="address">
                            <div className="phone-text">
                                <a href={`tel:${settings.phone}`}><FontAwesomeIcon icon={faPhone} />  {settings.phone}</a>

                                {settings.bussiness_hours.map((day: any, index: number) => (
                                    <p className='mb-1' key={index}>{day.day} <span>{formatTime(day.s_time)} - {formatTime(day.e_time)}</span> </p>
                                ))}
                            </div>
                        </div> */}

                        <div className="header-icons">
                            {/* <span className="mobile-search-btn" onClick={() => setSearchActive(prev => !prev)}>
                                <FontAwesomeIcon icon={faSistrix} />
                            </span> */}


                            {auth.user ? (
                                <>
                                    <div className="dropdown">
                                        <button className="btn  dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                            {auth.user?.name}
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                            <li>
                                                <a
                                                    className="dropdown-item front-use-btn"
                                                    href={
                                                        auth.user
                                                            ? auth.user.role_id === 2
                                                                ? '/customer/dashboard'
                                                                : auth.user.role_id === 1
                                                                    ? '/admin/dashboard'
                                                                    : auth.user.role_id === 3
                                                                        ? '/installor/dashboard'
                                                                        : '/'
                                                            : ''
                                                    }>
                                                    <span>My Profile</span> 
                                                </a>
                                            </li>
                                            <li>
                                                <a className="dropdown-item front-use-btn" onClick={handleLaqout}>
                                                   <span>Logout</span> 
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </>

                            ) : (
                                <a
                                    href="/login"
                                    className='user mob-hidden'

                                >
                                    <img src={userIcon} alt="user-icon" />
                                    <span> Login/register</span>
                                </a>
                            )}


                            {/* <Link className="wishlist user mob-hidden" onClick={handleWishlist}>
                                <i className="fa-regular fa-heart"></i>
                                <span>Wishlist</span>
                            </Link> */}

                            <Link className='cart' href='/cart'>
                                <img src={basket} alt="basket" />
                                <span className="mob-hidden"> Basket</span>
                                <b>{cart_count}</b>
                            </Link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}



export default Header